module.exports = __webpack_public_path__ + "img/circulo_banner_final.6c5254e4.png";